import React from 'react'

import { dateToUTC } from '../../lib/formats'
import { DateTypeProvider, CapitalizedTextTypeProvider } from '../UI/FormatProviders'
import DataGrid from '../UI/DataGrid'
import ProjectCard from './ProjectCard'

const ListInactiveProjects = props => {
  const gridColumns = [
    { name: 'id', title: 'Docket' },
    { name: 'projectTypeName', title: 'Project type' },
    { name: 'name', title: 'Campaign' },
    { name: 'product', title: 'Product' },
    { name: 'client', title: 'Client' },
    { name: 'agencyProducer', title: 'External PM' },
    { name: 'user', title: 'Int. Producer' },
    { name: 'state', title: 'State' },
    { name: 'date', title: 'Date' },
    { name: 'updatedAt', title: 'Updated' }
  ]

  const gridRowMappingFn = project => {
    const id = project.id
    const client = project.included('client').attributes
    const agency = project.included('agency').attributes
    const agencyProducer = project.included('agencyProducer').attributes
    const user = project.included('user').attributes
    const {
      name,
      projectTypeName,
      product,
      state,
      date,
      updatedAt
    } = project.attributes

    return {
      id: Number(id),
      projectTypeName: projectTypeName,
      name: name,
      product: product,
      client: client ? client.name : 'N/A',
      agency: agency ? agency.name : 'N/A',
      agencyProducer: agencyProducer ? agencyProducer.fullName : 'N/A',
      user: user ? user.fullName : 'N/A',
      state: state,
      date: dateToUTC(date),
      updatedAt: dateToUTC(updatedAt)
    }
  }

  const gridHiddenColumns = ['updatedAt']
  const tableColumnVisibilityExtensions = [
    { columnName: 'updatedAt', togglingEnabled: true }
  ]

  const gridSorting = [
    { columnName: 'projectTypeName', direction: 'asc' },
    { columnName: 'updatedAt', direction: 'desc' }
  ]

  const filteringStateColumnExtensions = [
    { columnName: 'date', filteringEnabled: false },
    { columnName: 'updatedAt', filteringEnabled: false }
  ]

  const tableColumnExtensions = [
    { columnName: 'id', align: 'center', width: 100 },
    { columnName: 'projectTypeName', width: 150 },
    { columnName: 'state', width: 100 },
    { columnName: 'date', width: 160 },
    { columnName: 'updatedAt', width: 160 }
  ]

  // Formatted columns
  const typeProviders = [
    <CapitalizedTextTypeProvider key={0} for={['state']} />,
    <DateTypeProvider key={1} for={['date', 'updatedAt']} />
  ]

  // Details dialog style
  const detailsDialogStyle = {
    width: '90%',
    maxWidth: 'none',
    height: '90vh'
  }

  // Passthrough props
  const otherProps = {
    disableHeader: props.disableHeader,
    disablePager: props.disablePager,
    disableFilters: props.disableFilters,
    disableSearch: props.disableSearch,
    disableVisibility: props.disableVisibility,
    rowClickFn: props.rowClickFn,
    rowDetailComponent: props.rowDetailComponent
  }

  const inactiveStates = [
    'archived',
    'dead'
  ]

  return (
    <DataGrid
      disableNew
      serverFilters={{states: inactiveStates}}
      resourceAPIEndpoint="projects"
      resourceSingularName="inactive project"
      resourcePluralName="inactive projects"
      resourceIncludes={['client', 'agency', 'agencyProducer', 'user']}
      nameAttribute="name"
      clientRootPath="/projects"
      gridColumns={gridColumns}
      gridHiddenColumns={gridHiddenColumns}
      tableColumnVisibilityExtensions={tableColumnVisibilityExtensions}
      gridRowMappingFn={gridRowMappingFn}
      gridSorting={gridSorting}
      filteringStateColumnExtensions={filteringStateColumnExtensions}
      tableColumnExtensions={tableColumnExtensions}
      detailsCard={ProjectCard}
      typeProviders={typeProviders}
      detailsDialogStyle={detailsDialogStyle}
      {...otherProps}
    />
  )
}

export default ListInactiveProjects



// WEBPACK FOOTER //
// ./src/components/Projects/ListInactiveProjects.jsx